<template>
  <span class="calendar-icon"
    :class="classHint"
  >
    <!-- <CheckSquareFill v-if="isMatch(ITEM_TYPES.TICKETED)" /> -->
    <!-- <TicketFill v-if="isMatch(ITEM_TYPES.TICKETED)" /> -->
    <SquareFillCheck v-if="isMatch(ITEM_TYPES.TICKETED)" />
    <!-- <TicketSquare v-else-if="isMatch(ITEM_TYPES.BOOKABLE)" /> -->
    <SquareFillPlus v-else-if="isMatch(ITEM_TYPES.BOOKABLE)" />
    <Pinned v-else-if="isMatch(ITEM_TYPES.PINNED)" />
    <SquareFill v-else-if="isMatch(ITEM_TYPES.APPOINTMENT)" />
    <DashCircleFill v-else-if="isMatch(ITEM_TYPES.DELETED)"  />
    <CheckCircleFill v-else-if="isMatch(ITEM_TYPES.CONFIRMED)" />
    <SendFill v-else-if="isMatch(ITEM_TYPES.INBOUND)" />
    <SendFill v-else-if="isMatch(ITEM_TYPES.OUTBOUND)" />
    <Queued v-else-if="isMatch(ITEM_TYPES.QUEUED)" />
  </span>
</template>

<script>
/* ICON CLASSES/SIZES:
 * .tiny    : 12px
 * .default : 16px (implicit sizing, not configured)
 * .large   : 40px
 */

import {ITEM_TYPES} from '@/components/Config';
import {FLAGS} from '@/utils/Item';
import CheckCircleFill from '@/components/icons/CheckCircleFill';
// import CheckSquareFill from '@/components/icons/CheckSquareFill';
import DashCircleFill from '@/components/icons/DashCircleFill';
// import OctagonFill from '@/components/icons/OctagonFill';
import Pinned from '@/components/icons/Pinned';
import Queued from '@/components/icons/Queued';
import SendFill from '@/components/icons/SendFill';
import SquareFill from '@/components/icons/SquareFill';
import SquareFillCheck from '@/components/icons/SquareFillCheck';
import SquareFillPlus from '@/components/icons/SquareFillPlus';
// import TicketFill from '@/components/icons/TicketFill';
// import TicketSquare from '@/components/icons/TicketSquare';

import {Filter} from '@/utils/Filter';

const ICON_CLASS_MAP = {};
const ICON_CLASSES = [
    [ITEM_TYPES.TICKETED, 'calendar-icon-appointment-confirmed'],
    [ITEM_TYPES.BOOKABLE, ''],
    [ITEM_TYPES.PINNED, ''],
    [ITEM_TYPES.APPOINTMENT, ''],
    [ITEM_TYPES.DELETED, 'calendar-icon-meeting-deleted'],
    [ITEM_TYPES.CONFIRMED, 'calendar-icon-meeting-confirmed'],
    [ITEM_TYPES.INBOUND, 'calendar-icon-meeting-inbound'],
    [ITEM_TYPES.OUTBOUND, 'calendar-icon-meeting-outbound'],
    [ITEM_TYPES.QUEUED, 'calendar-icon-meeting-queued'],
]
// .reduce((prev,cur) => prev[cur[0]] = cur[1],{})
ICON_CLASSES.forEach( (pair) => { ICON_CLASS_MAP[pair[0]] = pair[1]; });
// console.log(ICON_CLASS_MAP)

export default {
    name: "CalendarIcon",
    components: {
        CheckCircleFill,
        // CheckSquareFill,
        DashCircleFill,
        // OctagonFill,
        // PatchExclamationFill,
        Pinned,
        Queued,
        SendFill,
        SquareFill,
        SquareFillCheck,
        SquareFillPlus,
        // TicketFill,
        // TicketSquare,
    },
    props: {
        item: {
            type: Object,
            required: false,
        },
        me: {
            type: Object,
            required: false,
        },
        force: {
            type: String,
            required: false
        }
    },
    methods: {
        isMatch(name) {
            return name == this.iconType;
        },
    },
    computed: {
        classHint() {
            var hints = [];
            var hints_icon = ICON_CLASS_MAP[this.iconType];
            if (hints_icon) {
                hints.push(hints_icon);
            }
            if (this.item !== undefined) {
                let hint_track = Filter.itemToClass(this.item);
                hints.push(hint_track);

                if (this.item.flags.includes(FLAGS.DELETED)) {
                    hints.push('calendar-icon-meeting-deleted');
                }
            }
            
            return hints;
            /*
            if (this.item !== undefined) {
                let hint_icon = ICON_CLASS_MAP[this.iconType];
                let hint_track = Filter.itemToClass(this.item);
                return `${hint_icon} ${hint_track}`;
            }
            return null;
            */
        },
        iconType() {
            if (this.force) {
                if (Object.values(ITEM_TYPES).includes(this.force)) {
                    return this.force;
                } else {
                    console.log("Icon not recognised:", this.force);
                    return null;
                }
            }
            if (this.item === undefined) { return null; }

            // if (Filter.isTicketed(this.item)) {
            //     return ITEM_TYPES.TICKETED;
            // } else if (Filter.isAppointment(this.item)) {
            //     return ITEM_TYPES.APPOINTMENT;
            // // Don't use the deleted icon unless FORCED to.
            // // But _do_ include an isDeleted class hint
            // // } else if (Filter.isDeleted(this.item)) {
            // //     return ITEM_TYPES.DELETED;
            // } else if (Filter.isMeetingConfirmed(this.item)) {
            //     return ITEM_TYPES.CONFIRMED;
            // } else if (Filter.isMeetingPendingAttendeeId(this.item, this.me.id)) {
            //     return ITEM_TYPES.INBOUND;
            // } else if (Filter.isMeetingPendingBookerId(this.item, this.me.id)) {
            //     return ITEM_TYPES.OUTBOUND;
            // }
            if (this.item.flags === undefined) { return null; }

            if (this.item.flags.includes(FLAGS.APPOINTMENT)) {
                // No icon for hidden track items
                if (this.item.flags.includes(FLAGS.TRACK_HIDDEN)) { return null; }

                if (this.item.flags.includes(FLAGS.TICKETED)) {
                    return ITEM_TYPES.TICKETED;
                } else if (this.item.flags.includes(FLAGS.BOOKABLE)) {
                    return ITEM_TYPES.BOOKABLE;
                } else {
                    if (this.isPinned) {
                        return ITEM_TYPES.PINNED;
                    }
                    return ITEM_TYPES.APPOINTMENT;
                }
            }
            
            if (this.item.flags.includes(FLAGS.MEETING)) {
                if (this.item.flags.includes(FLAGS.CONFIRMED)) {
                    return ITEM_TYPES.CONFIRMED;
                } else if (this.item.flags.includes(FLAGS.INBOUND)) {
                    return ITEM_TYPES.INBOUND;
                } else if (this.item.flags.includes(FLAGS.OUTBOUND)) {
                    return ITEM_TYPES.OUTBOUND;
                }
            }
            return null;
        },
        isPinned() {
            return (this.item && this.item.in_schedule);
        }
    },
    beforeCreate() {
        this.Filter = Filter;
        this.ITEM_TYPES = ITEM_TYPES;
    },
}
</script>

<style>
:root {
  --calendar-icon-tiny: 12px;
  --calendar-icon-default: 16px;
  --calendar-icon-large: 40px;
}
.calendar-icon {
    display: inline-block;
}
.calendar-icon svg {
    width: 100%;
    height: 100%;
}
/* Explicit sizing */
.calendar-icon {
  max-height: var(--calendar-icon-default);
  max-width: var(--calendar-icon-default);
  min-height: var(--calendar-icon-default);
  min-width: var(--calendar-icon-default);
  height: var(--calendar-icon-default);
  width: var(--calendar-icon-default);
}
.calendar-icon.tiny {
  max-height: var(--calendar-icon-tiny);
  max-width: var(--calendar-icon-tiny);
  min-height: var(--calendar-icon-tiny);
  min-width: var(--calendar-icon-tiny);
  height: var(--calendar-icon-tiny);
  width: var(--calendar-icon-tiny);
}
.calendar-icon.large {
  max-height: var(--calendar-icon-large);
  max-width: var(--calendar-icon-large);
  min-height: var(--calendar-icon-large);
  min-width: var(--calendar-icon-large);
  height: var(--calendar-icon-large);
  width: var(--calendar-icon-large);
}


.calendar-icon-meeting-inbound svg {
    transform: rotate(180deg);
}

.calendar-icon-appointment-confirmed,
.calendar-icon-meeting-confirmed {
    /* color: #090; */
    color: var(--col-meeting-confirmed);
}

.calendar-icon-meeting-outbound,
.calendar-icon-meeting-queued #outbound {
    color: var(--col-meeting-outbound);
    /* color: #f90; */
}
.calendar-icon-meeting-inbound,
.calendar-icon-meeting-queued #inbound {
    color: var(--col-meeting-inbound);
    /* color: #c00; */
}

/* Final rule to override the others */
/* (Apart from the .track-orderN rules below, but we don't currently show deleted Appointments) */
.calendar-icon-meeting-deleted {
    color: var(--col-meeting-deleted);
    /* color: #999; */
}

/* ICON THEMING */
/* TODO: Move this to CalendarIcon */
/*
#calendar-app  .bi-check-circle-fill {
    color: #090;
}
#calendar-app .bi-hourglass-split,
#calendar-app .calendar-icon-meeting-outbound {
    color: #f90;
}
/* #calendar-app .bi-patch-exclamation-fill */
/*
#calendar-app .calendar-icon-meeting-inbound {
    color: #c00;
}
*/

/*
#calendar-app .bi-octagon-fill,
#calendar-app .bi-x-circle-fill {
    color: #999;
}
*/


/* Colourblind-safe 'Light' palette
  https://personal.sron.nl/~pault/#fig:scheme_light
  77AADD Light blue
  99DDFF Light cyan
  44BB99 Mint
  BBCC33 Pear
  AAAA00 Olive
  EEBB88 Light yellow
  EE8866 Orange
  FFAABB Pink
  DDDDDD Pale grey
*/

/*
.track0 .calendar-icon {
  color: #77AADD;
}
.track-order .calendar-icon,
.track-order0 .calendar-icon { 
  color: #77AADD;
}
.track-order1 .calendar-icon {
  color: #99DDFF;
}
.track-order2 .calendar-icon {
  color: #44BB99;
}
.track-order3 .calendar-icon {
  color: #BBCC33;
}
.track-order4 .calendar-icon {
  color: #AAAA00;
}
.track-order5 .calendar-icon {
  color: #EEBB88;
}
.track-order6 .calendar-icon {
  color: #EE8866;
}
.track-order7 .calendar-icon {
  color: #FFAABB;
}
*/

.track0 .calendar-icon {
  color: var(--col-track0);
}
.track-order .calendar-icon,
.track-order0 .calendar-icon { /* Corner-cases for trackless Appointments */
  color: var(--col-track0);
}
.track-order1 .calendar-icon {
  color: var(--col-track1);
}
.track-order2 .calendar-icon {
  color: var(--col-track2);
}
.track-order3 .calendar-icon {
  color: var(--col-track3);
}
.track-order4 .calendar-icon {
  color: var(--col-track4);
}
.track-order5 .calendar-icon {
  color: var(--col-track5);
}
.track-order6 .calendar-icon {
  color: var(--col-track6);
}
.track-order7 .calendar-icon {
  color: var(--col-track7);
}
</style>